import { render, staticRenderFns } from "./BulkSendManualEntries.vue?vue&type=template&id=a8db0606&scoped=true&lang=pug"
import script from "./BulkSendManualEntries.vue?vue&type=script&lang=js"
export * from "./BulkSendManualEntries.vue?vue&type=script&lang=js"
import style0 from "./BulkSendManualEntries.vue?vue&type=style&index=0&id=a8db0606&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8db0606",
  null
  
)

export default component.exports